import * as yup from "yup";

export const filtersValidation = yup.object({
  dateFrom: yup.date().transform((curr, orig) => (orig === "" ? undefined : curr)),
  dateTo: yup
    .date()
    .transform((curr, orig) => (orig === "" ? undefined : curr))
    .when("dateFrom", (dateFrom: any, schema: any) => {
      return dateFrom !== ""
        ? schema.min(yup.ref("dateFrom"), "The start date must be before the end date.")
        : schema;
    }),
});
